// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"624a93a2","642":"72544493"}[chunkId] + ".chunk.js";
};